<template lang="pug">
.theme.skin(:class='themeNamespace')
  keep-alive
    component.layout(:is='layout')
      component.module(:is='module()', :class='className')
</template>

<script>
/* eslint no-multi-spaces: 0 */

import User              from '@/core/user'
import Themes            from '@/components/Themes'
import Layouts           from '@/components/Layouts'
import Components        from '@/components/_modules'

import notImplemented    from '@/components/GeneralViews/NotImplemented.vue'
import legacyModule      from '@/components/LegacyContainer'
import loadingIndicators from '@/core/loading-indicators'

import {allowedModules}  from '@/core/legacy-auth'
import tabs              from '@/core/site-map/map.json'

export default {
  created() {
    // Apply theme
    if (global.config.enableThemes) {
      Themes.app[this.themeNamespace] ? Themes.app[this.themeNamespace]() : Themes.app['default']()
    }
  },

  computed: {
    themeNamespace: () => global.config.enableThemes && global.config.namespace ||
                          User.get() && User.get().theme && Themes.app[User.get().theme] && User.get().theme ||
                          'default',

    layout() {
      const app    = this._self
      const route  = app.$route
      let module   = Components[route.params.page || route.name]

      // always use `navless` layout on `create` action
      if (route.params.action === 'create') return Layouts.navless

      if (route.params.section &&
        Components[route.params.page + '/' + route.params.section]
      ) {
        module = Components[route.params.page + '/' + route.params.section]
      }

      if (module && module.layout) {
        return Layouts[module.layout]
      } else {
        // return Layouts.default
        if (global.config.layout) return Layouts[global.config.layout] || Layouts.default
        return Layouts.other
      }
    }
  },

  data() {
    return {
      className: '',

      module() {
        const app     = this._self
        const route   = app.$route

        skipToSubmodule.call(this)

        const module = getModule(route)

        // legacy modules
        if (route.params.namespace === 'i') {
          return legacyModule
        }

        if (module) {
          module
            .on('afterLoad', () => loadingIndicators.hook.stop.call(app) &&  module.legacy && (app.className = 'legacy'))
            .on('beforeLoad', () => loadingIndicators.hook.start.call(app))

          global.app.currentModule = (route.params.section || route.params.page || route.name).split('-')[0]

          return module.module || module
        } else {
          return route.params.section ? legacyModule : notImplemented
        }
      }
    }
  }
}

/**
 * Returns the module based on route
 *
 * @param {object} route - current route
 * @returns {object} module
 */
function getModule(route) {
  var module = Components[route.params.page || route.name]

  // pack submodule action
  if (module && module.pack && route.params.action) {
    module = Components[route.params.section + '/' + route.params.action]
  }
  // pack submodule
  if (module && module.pack && route.params.section) {
    module = Components[route.params.section]
  }

  // submodule
  if (route.params.section &&
    Components[route.params.page + '/' + route.params.section]
  ) {
    module = Components[route.params.page + '/' + route.params.section]
  }

  // config sitemap
  if (route.params.section &&
    global.config.namespace &&
    global.config.sitemap &&
    global.config.sitemap[global.config.namespace] &&
    global.config.sitemap[global.config.namespace][route.params.page] &&
    global.config.sitemap[global.config.namespace][route.params.page].subtabs &&
    global.config.sitemap[global.config.namespace][route.params.page].subtabs[route.params.section]
  ) {
    module = Components[route.params.page + '/' + route.params.section]
  }

  return module
}

/**
 * Navigates to first module in pack or to configured entry point
 */
function skipToSubmodule() {
  if (this.$router.currentRoute.params.namespace === 'docs') return

  const route       = this.$router.currentRoute
  const module      = Components[route.params.page || route.name]

  const allowed     = allowedModules()[route.params.page]
  const submodules  = tabs[route.params.page] && tabs[route.params.page].pack || null
  const subtabs     = Components[route.params.page] && Components[route.params.page].notImplemented ||
                      Components[route.params.page] && Components[route.params.page].pack

  if (!allowed.subtabs) return

  const firstModule = submodules
                      ? submodules[allowed.subtabs[Object.keys(allowed.subtabs)[0]]]
                      : allowed.subtabs[Object.keys(allowed.subtabs)[0]]

  const namespace = Components[firstModule] ? 'd' : 'i'

  if (firstModule && allowed && !route.params.section && subtabs) {
    this.$router.push('/' + namespace + '/' + route.params.page + '/' + firstModule + '/')
  }

  if (module && module.entry && !route.params.section) {
    this.$router.push(module.entry)
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?876d168a